import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import type { CardRenderItem } from '../cardRenderItemGenerator';

export const useLogDisplayCardItems = () => {
  const displayLoggedList = useRef<number[]>([]);

  const logDisplayCardItems = useCallback<
    NonNullable<FlatListProps<CardRenderItem>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (index === null || !isViewable) {
        return;
      }
      if (displayLoggedList.current.includes(index)) {
        return;
      }
      displayLoggedList.current.push(index);

      if (item.type === 'PRIMARY_CARD') {
        bridge.logAnalyticsEvent({
          name: 'DISPLAY_PRIMARY_CARD',
          analytics: item.logging.analytics,
          ably_only_log: item.logging.ably_only_log,
        });
      } else {
        bridge.logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          analytics: item.logging.analytics,
          ably_only_log: item.logging.ably_only_log,
        });
        if (isNotNil(item.item.ad)) {
          bridge.logAdEvent({
            action: AdAction.DISPLAY,
            ad: item.item.ad,
          });
        }
      }
    });
  }, []);

  return { logDisplayCardItems };
};
